import React, { useState } from 'react'
import { Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { t, Trans } from '@lingui/macro'

import { SortablePatientsList } from './SortablePatientsList'
import { useQueuedPatientsLoader } from '../model/useQueuedPatientsLoader'

type PatientQueueModalProps = {
  onClose: () => void
  open: boolean
}

export function PatientQueueModal({ onClose, open }: PatientQueueModalProps) {
  const queuedPatients = useQueuedPatientsLoader()

  const totalPatients = queuedPatients.length

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Trans>Nurse queue</Trans>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {totalPatients} {t`patient(s) in queue`}
        </Typography>
        <Box sx={{ maxHeight: 420, overflow: 'auto' }}>
          <SortablePatientsList patients={queuedPatients} />
        </Box>
      </DialogContent>
      <DialogActions sx={{ pt: 1 }}>
        <Button onClick={onClose}>
          <Trans>Close</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
